<template>
  <div class="ftpdetails-container">
    <b-form v-if="tempForm">
      <div class="ftp-port-host-cont">
        <b-form-group class="ftp_host_group" label="FTP Host" label-for="ftp_host">
          <b-form-input id="ftp_host" type="text" v-model="tempForm.hostName" required>
          </b-form-input>
        </b-form-group>
        <b-form-group class="ftp_port_group" label="FTP Port" label-for="ftp_port">
          <b-form-input id="ftp_port" type="text" v-model="tempForm.hostPort" required placeholder="">
          </b-form-input>
        </b-form-group>
      </div>
      <b-form-group id="exampleInputGroup1" label="FTP Username" label-for="ftp_username">
        <b-form-input id="ftp_username" type="text" autocomplete v-model="tempForm.hostUserName" required placeholder="">
        </b-form-input>
      </b-form-group>
      <b-form-group id="exampleInputGroup1" label="FTP Password" label-for="ftp_password">
        <password-input idFor="ftp_password" v-model="tempForm.hostPassword"></password-input>
      </b-form-group>
      <b-form-group label="Connection Type">
        <b-form-radio-group id="radios1" v-model="selected" :options="options" name="radioOpenions" @input="updateConnectionType(selected)">
        </b-form-radio-group>
      </b-form-group>

      <b-form-checkbox id="checkbox1" v-model="tempForm.hostPassive" value="1" unchecked-value="0">
        Use Passive Mode
      </b-form-checkbox>
      <hr/>
      <b-alert :show="showFTPError" variant="warning">
        <p>Could not connect to the server. Please check the credentials.</p>
      </b-alert>
      <b-form class="ftp-target-folder-edit">

        <b-form-group id="exampleInputGroup1" label="Select your target folder" label-for="target_folder" description="To create a new folder, enter the new folder name after the parent folder.">
          <b-dropdown ref="ddown" id="ddown1" text="" variant="outline-secondary" class="m-md-2" @show="loadTree=true" @hide="loadTree=false">
            <file-tree v-if="loadTree" :model="files" :init="true" :ftpDetails="tempForm" @onSelect="setFolder" @onError="handleFTPError" @onSuccess="hideError"></file-tree>
          </b-dropdown>
          <b-form-input id="target_folder" class="target_folder" type="text" v-model="tempForm.remoteFolder" required>

          </b-form-input>
        </b-form-group>
        <b-form-group id="exampleInputGroup1" label="Full URL to the target folder" label-for="target_folder_url" description="Example: http://yourdomain.com/path/to/targetFolder">
          <b-form-input id="target_folder_url" ref="siteURL" type="text" v-model="tempForm.newSiteURL" required placeholder="http://yourdomain.com/path">
          </b-form-input>
        </b-form-group>
        <div class="ftp-point-to-same-folder">
          <span>These 2 should point to the same folder</span>
        </div>
      </b-form>
    </b-form>
  </div>
</template>

<script>
import axios from 'axios';
import Vue from 'vue';
import param from 'jquery-param';
import FileTree from '../Common/FileTree';
import PasswordInput from '../Common/PasswordInput';

export default {
  name: 'ftpdetails',
  props: ['value'],
  components: {
    FileTree,
    PasswordInput
  },
  data() {
    return {
      serverURL: window.serverURL,
      files: [],
      loadTree: false,
      showFTPError: false,
      tempForm: null,
      selected: 'use_ftp',
      options: [
        { text: 'FTP', value: 'use_ftp' },
        { text: 'FTP SSL', value: 'use_ftpssl' },
        { text: 'SFTP', value: 'use_sftp' }
      ]
    };
  },
  mounted() {
    if (this.value.ftpDetails) {
      let ftpDetails = this.value.ftpDetails;
      this.tempForm = _.cloneDeep(ftpDetails);
      if (this.tempForm.use_ftp === '1') {
        this.selected = 'use_ftp';
      } else if (this.tempForm.use_ftpssl === '1') {
        this.selected = 'use_ftpssl';
      } else if (this.tempForm.use_sftp === '1') {
        this.selected = 'use_sftp';
      }
    } else {
      this.value.ftpDetails = {
        hostPort: 21
      };
      this.tempForm = {
        hostPort: 21
      };
      this.$emit('input', this.value);
    }
  },
  watch: {
    tempForm(newVal) {
      this.value.ftpDetails = newVal;
      this.$emit('input', this.value);
    }
  },
  methods: {
    setFolder(event) {
      Vue.set(this.tempForm, 'remoteFolder', event.path + event.name);
      this.$refs.ddown.hide();
    },
    handleFTPError(event) {
      this.showFTPError = true;
      this.$refs.ddown.hide();
    },
    hideError(event) {
      this.showFTPError = false;
    },
    loadFiles(dir) {},
    updateConnectionType(mode) {
      if (mode === 'use_sftp') {
        Vue.set(this.tempForm, 'use_sftp', '1');
        Vue.set(this.tempForm, 'use_ftp', '0');
        Vue.set(this.tempForm, 'use_ftpssl', '0');
        if (this.value.ftpDetails.hostPort == 21) {
          this.value.ftpDetails.hostPort = 22;
        }
      } else if (mode === 'use_ftpssl') {
        Vue.set(this.tempForm, 'use_sftp', '0');
        Vue.set(this.tempForm, 'use_ftp', '0');
        Vue.set(this.tempForm, 'use_ftpssl', '1');
      } else {
        Vue.set(this.tempForm, 'use_sftp', '0');
        Vue.set(this.tempForm, 'use_ftp', '1');
        Vue.set(this.tempForm, 'use_ftpssl', '0');
        if (this.value.ftpDetails.hostPort == 22) {
          this.value.ftpDetails.hostPort = 21;
        }
      }
    }
  }
};
</script>

<style>
</style>
